// extracted by mini-css-extract-plugin
export default {"important":"Important_important__jIIAG","body":"Important_body__1tr7i","image":"Important_image__N4STG","text":"Important_text__QORCr"};